// Shared react-data-table-component styling to match the antd Table look & brand color.
const dataTableCustomStyles = {
  table: {
    style: {
      borderRadius: 8,
      overflow: "hidden",
      border: "1px solid #f0f0f0",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#fafafa",
      borderBottomWidth: "1px",
      borderBottomColor: "#f0f0f0",
      minHeight: "48px",
    },
  },
  headCells: {
    style: {
      fontWeight: 600,
      fontSize: "14px",
      color: "rgba(0, 0, 0, 0.88)",
    },
  },
  rows: {
    style: {
      borderBottomWidth: "1px",
      borderBottomColor: "#f0f0f0",
      fontSize: "14px",
      color: "rgba(0, 0, 0, 0.88)",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#fdece4",
      borderBottomColor: "#f0f0f0",
      outline: "none",
    },
  },
  pagination: {
    style: {
      borderTopWidth: "1px",
      borderTopColor: "#f0f0f0",
    },
  },
};

export default dataTableCustomStyles;
